import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUser, IUsersInitialState, IUsersList } from '@types';

import { initialUsers } from './initialState';

export const usersSlice = createSlice({
    name: 'users',
    initialState: initialUsers(),
    reducers: {
        setUsers(state: IUsersInitialState, action: PayloadAction<IUsersList>) {
            state.usersList = action.payload;
        },

        setUser(state: IUsersInitialState, action: PayloadAction<IUser | null>) {
            state.user = action.payload;
        },
    },
});
